import {FUND_CENTRE_SET_VALUE, FUND_CENTRE_TOGGLE_TRANSITION} from "../../../actions/fundCentre/fundTable";
import {fundTableRules} from "./fundTable";

export const fundCentreRules = (store, next, action) => {
    if (action.type.startsWith(FUND_CENTRE_SET_VALUE) || action.type.startsWith(FUND_CENTRE_TOGGLE_TRANSITION))
        return fundTableRules(store, next, action);

    return null;
};
